export function inputFilled(){
    function applyFilled(input: HTMLInputElement): void {
        const formItem = input.closest<HTMLElement>(".form-item");
        if (!formItem) return;

        if (input.value.trim()) {
            formItem.classList.add("filled");
        } else {
            formItem.classList.remove("filled");
        }
    }

    // Делегирование: ловим ввод на всём документе (можно повесить на общий контейнер формы)
    document.addEventListener("input", (e: Event) => {
        const target = e.target;
        if (!(target instanceof HTMLInputElement)) return;
        if (!target.classList.contains("input-label")) return;
        applyFilled(target);
    });

    // На случай автозаполнения/программных изменений
    document.addEventListener("change", (e: Event) => {
        const target = e.target;
        if (!(target instanceof HTMLInputElement)) return;
        if (!target.classList.contains("input-label")) return;
        applyFilled(target);
    });

    // Первичная синхронизация для уже существующих полей
    document.querySelectorAll<HTMLInputElement>(".input-label")
        .forEach(applyFilled);

    // Если используешь bfcache/автозаполнение — досинхронизация после возврата на страницу
    window.addEventListener("pageshow", () => {
        document.querySelectorAll<HTMLInputElement>(".input-label")
            .forEach(applyFilled);
    });
}